import(/* webpackMode: "eager" */ "/vercel/path0/web/src/app/games/student/join/page.tsx");
